module.exports = __webpack_public_path__ + "0c22031758f9a1f9b025b954261018cc.pdf";